<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">

    <mat-tab label="Individual Sessions">

        <app-individual-assessment-table></app-individual-assessment-table>
    </mat-tab>

    <mat-tab label="Group Sessions"><app-group-session-table></app-group-session-table>
    </mat-tab>
    <mat-tab label="Assessments">
        <app-assessement-table></app-assessement-table>
    </mat-tab>
    <mat-tab label="Report">
        <app-counseling-child-report></app-counseling-child-report>
    </mat-tab>
</mat-tab-group>

